import { cn } from '@shared/lib';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
}

const sizes = {
  sm: { mark: 'w-8', name: 'text-base', tag: 'text-[8px]' },
  md: { mark: 'w-10', name: 'text-[21px]', tag: 'text-[9px]' },
  lg: { mark: 'w-12', name: 'text-2xl', tag: 'text-[12px]' },
};

// Contented Fox на оранжевой L: прозрачный знак без внешних полей.
// showName добавляет название текстом; без него — только знак
// (свёрнутый сайдбар).
export function Logo({ className, size = 'md', showName = true }: LogoProps) {
  const s = sizes[size];
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <img
        src="/icons/contented-fox/logo-144.png"
        width={40}
        height={40}
        alt={showName ? '' : 'Lomora'}
        draggable={false}
        // max-w-none: иначе preflight-правило max-width:100% сплющивает плитку,
        // пока раскрывающийся сайдбар ещё узкий (min-w-0 у обёртки).
        className={cn('h-auto max-w-none shrink-0 select-none', s.mark)}
      />
      {showName && (
        // Одна строка и обрезка без переносов: пока сайдбар раскрывается (ширина
        // анимируется), надпись выезжает из-под края, а не прыгает по строкам.
        <div className="flex min-w-0 flex-col overflow-hidden whitespace-nowrap leading-none">
          <span className={cn('font-serif font-semibold tracking-[-0.01em] text-fg', s.name)}>Lomora</span>
          <span className={cn('mt-1 font-medium uppercase tracking-[0.18em] text-accent-hi', s.tag)}>
            Learn English
          </span>
        </div>
      )}
    </div>
  );
}
